import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { endpoints, getPath } from "./apiUtils";

export const useFeatureFlag = (name, scope) => {
  const path = getPath({
    endpoint: endpoints.featureFlags,
    path: [name, scope],
  });

  return useQuery(["featureflags", name, scope], async () =>
    axios.get(path).then((r) => r.data)
  );
};
